import React, { useState, useEffect } from 'react'
import { Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function TaxSetup() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['Tax_Access Specifier']);
    }

  }, []);


  return (
    <div className="tax-setup-page">

      <div className="row">

        <div className="row my-3 tax-setup-page-header">
          <div className="col-md-6">
            <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
              Tax {accessType === 'View' ? " / View Only Mode" : ""}
            </Typography>
          </div>
          <div className="col-md-6 d-flex justify-content-end"   >

            <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="tax-help-modal-title"
              dialogClassName="tax-setup-help-modal"

            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="tax-help-modal-title" >
                  Instructions to Add/Edit Tax
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-copy   { background: #ebf8ff; color: #2b6cb0; border: 1px solid #bee3f8; }
                  .badge-update { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  .badge-delete { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>
                  
                  {/* 1. CREATE TAX */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create a Tax Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Watch the guide below to learn how to add and configure a new tax setup step-by-step.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Taxes%20-%20create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. COPY TAX */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-copy">Copy</span>
                      <strong>How to Copy a Tax Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Learn how to replicate an existing tax configuration across locations quickly.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Taxes%20-%20copy.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 3. UPDATE TAX */}
                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to View or Update Tax Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        To view or update an existing tax setup, select the <strong>Account Name</strong> and <strong>Location Name</strong> and edit the required details based on the tax type.
                        <br /><br />
                        <em>Note: Changes can only be made on <strong>rental period</strong>, <strong>percentage/amount</strong>, and <strong>applicable</strong>. Once changes are made, click on <strong>save</strong> to automatically reflect the changes in the tax type table.</em>
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Taxes%20-%20edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 4. DELETE TAX */}
                  <Accordion.Item eventKey="3" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-delete">Delete</span>
                      <strong>How to Delete a Tax Setup</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        See how to safely remove existing tax setups from your records.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Taxes%20-%20delete.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>

          </div>
        </div>


        {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}

      </div>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </div>
  );
}
